// @flow
import _ from 'lodash';

export function compactJoin (...args: string[]): string {
	return _(args)
		.map(_.trim)
		.compact()
		.join(', ');
}

// region # выбор форм слова
/**
 * Тип объекта форм слова
 *
 * nominative - именительный падеж ед.ч e.g "полис"
 * genitive - родительный падеж ед.ч e.g "полиса"
 * genitive_plural - родительный падеж множ.ч e.g "полисов"
 */
export type TTextForms = {
	nominative: string,
	genitive: string,
	genitive_plural: string,
};

/**
 *  Выбор формы слова в зависимости от количества
 *
 * @param {number} count - количество
 * @param {TTextForms} textForms - объект форм слова
 * @return {string} - морма слова
 */
export function chooseWordCaseByNumeral (count: number, textForms: TTextForms): string {
	const numberHundred: number = 100;
	const numberTwentyOne: number = 21;
	const numberTen: number = 10;
	const numberFive: number = 5;
	count = Math.abs(count) % numberHundred;
	const v1 = count % numberTen;

	if (count > numberTen && count < numberTwentyOne) {
		return textForms.genitive_plural;
	}
	if (v1 === 1) {
		return textForms.nominative;
	}
	if (v1 > 1 && v1 < numberFive) {
		return textForms.genitive;
	}

	return textForms.genitive_plural;
}

// endregion

export function delSpaces (str: string): string {
	return str.replace(/\s/g, '');
}
